import React from 'react';
import {SVGIcon} from '@homeaway/react-svg';
import {HEART_SELECTED__24} from '@homeaway/svg-defs';
import {FormattedHTMLMessage} from 'react-intl';
import './slide-2.less';


export const Slide2 = ({
}) => (
    <div className="trip-board-onboarding-slide2">
        <div className="trip-board-onboarding-slide2__gray-circle"/>
        <div className="trip-board-onboarding-slide2__house1">
            <div className="trip-board-onboarding-slide2__white-circle">
                <SVGIcon className="text-danger" markup={HEART_SELECTED__24} />
            </div>
        </div>
        <div className="trip-board-onboarding-slide2__house2">
            <div className="trip-board-onboarding-slide2__white-circle">
                <SVGIcon className="text-danger" markup={HEART_SELECTED__24} />
            </div>
        </div>
        <div className="trip-board-onboarding-slide2__house3">
            <div className="trip-board-onboarding-slide2__white-circle">
                <SVGIcon className="text-danger" markup={HEART_SELECTED__24} />
            </div>
        </div>
        <div className="trip-board-onboarding-slide2__family-getaway">
            <div className="header text-emphasis">
                <FormattedHTMLMessage id={'tripboards.main.empty.board1'} defaultMessage={''} description="Trip Board title"/>
            </div>
            <div className="left-content"/>
            <div className="right-content">
                <div className="right-content__top" />
                <div className="right-content__bottom" />
            </div>
        </div>
    </div>
);

export default Slide2;



// WEBPACK FOOTER //
// ./src/universal/components/onboarding/content/static/slide-2/slide-2.js